import React from "react";
import { Paper } from "@mui/material";
import PropTypes from "prop-types";

/**
 * CPaper - A wrapper for MUI Paper with additional functionality
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - The content of the paper
 * @param {number} props.elevation - Shadow depth, corresponds to dp in the spec
 * @param {string} props.variant - The variant to use (elevation or outlined)
 * @param {boolean} props.square - If true, rounded corners are disabled
 * @param {Object} props.sx - Additional styling for the paper
 * @param {Object} props.theme - Theme object for styling
 * @returns {JSX.Element}
 */
const CPaper = ({
  children,
  elevation = 1,
  variant = "elevation",
  square = false,
  sx = {},
  theme,
  ...rest
}) => {
  // Default styles based on theme (if provided)
  const defaultSx = theme
    ? {
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
      }
    : {};

  return (
    <Paper
      elevation={elevation}
      variant={variant}
      square={square}
      sx={{ ...defaultSx, ...sx }}
      {...rest}
    >
      {children}
    </Paper>
  );
};

CPaper.propTypes = {
  children: PropTypes.node,
  elevation: PropTypes.number,
  variant: PropTypes.oneOf(['elevation', 'outlined']),
  square: PropTypes.bool,
  sx: PropTypes.object,
  theme: PropTypes.object,
};

export default CPaper;